import ClearAllIcon from '@mui/icons-material/ClearAll'
import { Grid, IconButton, List, ListSubheader } from '@mui/material'
import { useTasks } from './store'
export function TasksList() {
	const { tasks, types, getUpdaters, canClearAll, clearAll } = useTasks(
		(state) => ({
			tasks: state.tasksOrder.map((id) => state.tasks[id]).filter(Boolean),
			types: state.types,
			getUpdaters: state.getUpdaters,
			canClearAll: state.tasksOrder.every((id) =>
				['error', 'success'].includes(state.tasks[id].status),
			),
			clearAll: state.clearAll,
		}),
	)

	return (
		<List
			dense
			sx={{ minWidth: 350 }}
			subheader={
				<Grid
					container
					direction="row"
					sx={{
						justifyContent: 'space-between',
						alignItems: 'center',
						flex: 1,
						width: '100%',
					}}
				>
					<Grid sx={{ flex: 1 }}>
						<ListSubheader component="div" id="nested-list-subheader">
							Background Tasks
						</ListSubheader>
					</Grid>
					<Grid sx={{ paddingRight: 1 }}>
						<IconButton
							size="small"
							onClick={clearAll}
							title="Clear All"
							disabled={!canClearAll}
						>
							<ClearAllIcon fontSize="small" />
						</IconButton>
					</Grid>
				</Grid>
			}
		>
			{tasks.map((task) => {
				const type = types[task.type]

				if (!type) {
					return null
				}

				const { Component } = type

				return (
					<Component
						key={task.id}
						id={task.id}
						payload={task.payload}
						updaters={getUpdaters(task.id)}
					/>
				)
			})}
		</List>
	)
}
